import { isNil } from "lodash";
import { Feature } from "PFTypes/features";

export const getUnsatisfiedDependencies = (feature: Feature, features: Feature[]): string[] =>
  features
    .filter(({ name }) => feature.dependsOn && feature.dependsOn.includes(name))
    .filter(({ active }) => !active)
    .map(({ name }) => name);

export const featureDependenciesSatisfied = (feature: Feature, features: Feature[]): boolean => {
  if (isNil(feature.dependsOn)) {
    return true;
  }
  return features
    .filter(({ name }) => feature.dependsOn && feature.dependsOn.includes(name))
    .every(({ active }) => active);
};
